export default "__VITE_ASSET__tw0X4nhd__"